// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"Dropdown_dropdown__1g9dN","list":"Dropdown_list__1xeJp","nav-item":"Dropdown_nav-item__3xKYu"};